import React from 'react'
import PropTypes from 'prop-types'
import {injectIntl } from 'react-intl'

import Error from './form-input-error'
import Label from '../label'

class InputNumber extends React.Component {
    static WAIT_IN_MS = 1000;
    static propTypes = {
        label: PropTypes.string,
        value: PropTypes.number,
        errorStr: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        waitInMs: PropTypes.number
    }
    static defaultProps = {
        errorStr: 'app.error',
        value: ''
    }

    onChangeTimeout = false;

    constructor(props){
        super(props);
        this.state = {
            value: props.value,
            error: false
        };
    }

    handleChange(event) {
        let { value } = event.target
        this.setState({value})

        this.onChangeTimeout && clearTimeout(this.onChangeTimeout);
        this.onChangeTimeout = setTimeout( () => this.onChange(value), this.props.waitInMs || InputNumber.WAIT_IN_MS)
    }

    onChange(value) {
        let { onChange = false } = this.props
        if(!onChange) {
            return
        }
        let ret = onChange(value);
        let promise = ret.then ? ret : Promise.resolve(value)

        !promise._state && this.setState({loading: true})

        promise.then(e => this.setState({loading: false, error: false}))
            .catch( e => this.setState({loading: false, error: true}));
    }

    componentWillUnmount() {
        this.onChangeTimeout && clearTimeout(this.onChangeTimeout);
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({value: nextProps.value})
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        return nextProps.value !== this.state.value
    }

    render() {
        const { intl, label=false, className=false, errorStr='app.error', disabled } = this.props;
        const { error, value, loading } = this.state;

        return (<div className={"form form-text" + (className ? ' ' + className : '')}>
            <Label>{label}</Label>
            <div className={'form-data' + (error?' error':'')}>
                {(disabled || loading) ? <div className="disabled">{value}</div> :
                    <input type="number"
                        placeholder={label ? intl.formatMessage({id: label + '.placeholder'}) : ''}
                        onChange={this.handleChange.bind(this)}
                        onBlur={this.handleChange.bind(this)}
                        value={value} />}
                <Error visible={error} message={errorStr} />
            </div>
        </div>);
    }
}

export default injectIntl(InputNumber)

